import { useState, useEffect } from "react";
import { getAssociatedTagsApi } from "../api/tag.api";
import usePermissions from "./usePermissions";
import ErrorModal from "../components/ErrorModal";
import { useStateDebug } from "./useStateDebug";

const useTagAssociations = ({ entity, entityIds }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const permissions = usePermissions();

  const fetchAssociations = async () => {
    try {
      setLoading(true);
      const response = await getAssociatedTagsApi({
        entity,
        entityIds,
      });
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching tag associations:", error);
      ErrorModal.show(error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (entity && entityIds && entityIds.length > 0 && permissions.favourites) {
      fetchAssociations();
    } else {
      setData([]);
    }
  }, [entity, entityIds, permissions]);

  const reload = async () => {
    if (entity && entityIds && entityIds.length > 0 && permissions.favourites) {
      await fetchAssociations();
    }
  };

  return {
    data,
    loading,
    reload,
  };
};

export default useTagAssociations;
